import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { userHasTasksEnabledRedir } from '../core/auth';
import { useFeatureFlag } from '../core/hooks/useFeatureFlag';
import TasksV2Daily from '../views/taskTemplates/containers/TasksV2Daily';
import TasksV2Admin from '../views/taskTemplates/containers/TasksV2Admin';
import TasksV2Maintenance from '../views/taskTemplates/containers/TasksV2Maintenance';
import TasksV2WorkOrders from '../views/taskTemplates/containers/TasksV2WorkOrders';

const TasksV2Route = () => {
  const { site } = useParams<{ site: string }>();
  const tasksV2Enabled = useFeatureFlag('tasks-v2', true);

  if (!tasksV2Enabled) {
    return <Redirect to={`/${site}/tasks`} />;
  }

  return (
    <div className="container-fluid">
      <div className="page-main-content">
        <Switch>
          <Route path="/:site/tasks-v2" exact={true}>
            <TasksV2Daily />
          </Route>
          <Route path="/:site/tasks-v2/maintenance">
            <TasksV2Maintenance />
          </Route>
          <Route path="/:site/tasks-v2/projects">
            <Redirect to={`/${site}/tasks-v2/work-orders`} />
          </Route>
          <Route path="/:site/tasks-v2/work-orders">
            <TasksV2WorkOrders />
          </Route>
          <Route path="/:site/tasks-v2/admin">
            <TasksV2Admin />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default userHasTasksEnabledRedir(TasksV2Route);
